import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IAnalyticsKpisProps } from './IAnalyticsKpisProps';

/**
 * Тайли аналітики (прототип v4): Записи, Відкрито (синій), Прострочено (помаранчевий, нуль — приглушений), Виконано (зелений, «N% від
 * усіх»), залишок по відкритих (фіолетовий) — підпис 11px великими літерами, значення 30px/300 без групування розрядів (String(n)
 * прототипу: «15000»).
 */
export function AnalyticsKpis({ data, remainingLabel }: IAnalyticsKpisProps) {
  const { t } = useTranslation();
  const pct = data.total ? Math.round((data.done / data.total) * 100) : 0;
  const tiles = [
    { key: 'records', label: t('modBody.dash.records'), value: data.total, tone: '' },
    { key: 'open', label: t('modBody.dash.open'), value: data.open, tone: 'is-blue' },
    { key: 'overdue', label: t('modBody.dash.overdue'), value: data.overdue, tone: data.overdue ? 'is-orange' : 'is-muted' },
    { key: 'done', label: t('modBody.dash.done'), value: data.done, tone: 'is-green', note: data.total ? t('modBody.dash.pctOfAll', { pct }) : '' },
    ...(remainingLabel && data.remaining !== undefined ? [{ key: 'remaining', label: remainingLabel, value: data.remaining, tone: 'is-purple' }] : []),
  ];
  return (
    <div className="an-kpis">
      {tiles.map((k) => (
        <div key={k.key} className={cx('an-kpi', k.tone)}>
          <span className="an-kpi__label" title={k.label}>{k.label}</span>
          <span className="an-kpi__value">{String(k.value)}</span>
          <span className="an-kpi__note">{'note' in k ? k.note : ''}</span>
        </div>
      ))}
    </div>
  );
}
